module.exports = __webpack_public_path__ + "static/media/menage-groups.586670ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/menage-groups.jpg
// module id = 1915
// module chunks = 0